import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.container}>
      <p>	&copy;2023 Michael Gainey</p>
    </footer>
  );
}

export default Footer;